<template>
    <div class="filterContent">
        <div>
            <div class="flex1 text-align-left">
                <span class="model_title">联系方式</span>
            </div>
            <div class="model_content textArea">
                <Input class="contact" :onChange="changeNumber"/>
            </div>
            <div class="tips text-align-left">
                <p class="center">
                为了更好的服务请输入你的联系方式电话微信
                </p>
            </div>
            <br />
        </div>
    </div>
</template>

<script>
import Input from '../comm/Input';

export default {
  props: ['changeNumber'],
  name: 'FeedBackContact',
  components: {
      Input
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filterContent {
    height: fit-content;
    padding: 0 0.15rem;
    line-height: 0.35rem;
}
.textArea{
    width: calc( 100% - .3rem );
    padding: 0 0.15rem;
}
.contact {
    width: 100% !important;
    color: #000 !important;
}
.tips {
    color: #7F7F7F;
    width: 100%;
}
.tips p {
    padding: 0 0.15rem;
}
.center {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/feedBackElement/FeedBackContact.vue